import * as React from 'react';
import { ReactElement, useEffect } from 'react';
import { EditView, EditProps, EditContextProvider } from 'react-admin';
import { useParams } from 'react-router-dom';
import { useEditNodeController } from './controllers/useEditNodeController';

import NodeEditActions from './NodeEditActions';
import { useExpandedKeys } from './util';

/**
 * Alternative to <Edit> for tree nodes.
 *
 * Adds a button to add a child node in view actions.
 */
const EditNode = (
    props: EditProps & { children: ReactElement }
): ReactElement => {
    const { id: idProp } = props;
    const { id: routeId } = useParams<'id'>();
    const id = idProp || decodeURIComponent(routeId);
    const [, setExpandedKeys] = useExpandedKeys();

    // Automatically expand the node on mount
    useEffect(() => {
        setExpandedKeys(expandedKeys => {
            const key = id.toString();
            if (Array.isArray(expandedKeys)) {
                if (!expandedKeys.includes(key)) {
                    return [...expandedKeys, key];
                }
                return expandedKeys;
            }
            return [key];
        });
    }, [props.resource, id, setExpandedKeys]);

    const controllerProps = useEditNodeController(props);

    return (
        <EditContextProvider value={controllerProps}>
            <EditView actions={defaultActions} {...props} />
        </EditContextProvider>
    );
};

const defaultActions = <NodeEditActions />;

export default EditNode;
